import { registerPlugin } from '@capacitor/core';
const StreamHttp = registerPlugin('StreamHttp', {
    web: () => import('./web').then((m) => new m.StreamHttpWeb()),
});
export * from './definitions';
export { StreamHttp };
//# sourceMappingURL=index.js.map